function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Button, Collapse, Empty, Form } from 'antd';
import { ParametersWrapper, StyledCollapse } from './index.style';
import { onStatusChange, handleRequestError, output, splitParameters } from '../_helpers';
import client from '../../../feathers';
import RequestPanel from '../RequestPanel';
import ControlPanel from '../ControlPanel';
import CodeSamples from '../../../code-samples';
import ParameterRow from '../ParameterRow';
import Output from '../Output';
import { ExtraQueryBuilder, ExtraGlobal, ExtraOutput, ExtraParameters } from '../Extra';
import { DocsQueryBuilder, DocsEndpointParameters, DocsGlobalParameters } from '../Info';
var {
  Panel
} = Collapse;

var getCodeValues = values => _.reduce(values, function (result, obj, key) {
  if (obj.checked) {
    result[key] = obj.value;
  }

  return result;
}, {});

function ConsoleForm(_ref) {
  var {
    host = 'web',
    isAdmin,
    isLoggedIn,
    handleNotLoggedIn,
    endpoint,
    parameters,
    initialValues,
    screenWidth,
    initialScenarioId,
    customFunction,
    setCustomFunction
  } = _ref;
  var [form] = Form.useForm(); // State

  var [initial, setInitial] = useState(initialValues); // const [customFunction, setCustomFunction] = useState(initialCustomFunction);

  var [codeValues, setCodeValues] = useState({});
  var [endpointParameters, setEndpointParameters] = useState([]);
  var [globalParameters, setGlobalParameters] = useState([]);
  var [activeKey, setActiveKey] = useState(['1', '3']);
  var [outputAs, setOutputAs] = useState('default'); // Info

  var [queryInfoVisible, setQueryInfoVisible] = useState(false);
  var [endpointInfoVisible, setEndpointInfoVisible] = useState(false);
  var [globalInfoVisible, setGlobalInfoVisible] = useState(false);
  var [outputDrawerVisible, setOutputDrawerVisible] = useState(false); // Data fetching

  var [loading, setLoading] = useState(false);
  var [requestedData, setRequestedData] = useState(null);
  var [error, setError] = useState(null);
  useEffect(() => {
    form.resetFields();
    var [globalParams, endpointParams] = splitParameters(parameters);
    setGlobalParameters(globalParams);
    setEndpointParameters(endpointParams);
    setCodeValues(getCodeValues(initial));
  }, [initial]);

  var onFinish = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (values) {
      var query = _objectSpread({
        provider: endpoint.provider.name,
        endpoint: endpoint.name
      }, codeValues);

      setLoading(true);
      setRequestedData(null);
      setError(null);
      onStatusChange('loading');
      var {
        user
      } = yield client.reAuthenticate();
      var {
        email
      } = user;

      try {
        var data = yield client.service('api/query').find({
          query
        });
        setLoading(false);
        setRequestedData(data);
        setError(null);
        var handlerArgs = {
          endpoint,
          customFunction,
          data,
          host,
          parameters: query
        };
        var {
          handler
        } = output(handlerArgs)[outputAs];
        yield handler();
        onStatusChange('success');
        setActiveKey(['4']);
      } catch (error) {
        setLoading(false);
        setRequestedData(null);
        setError(error.toJSON());
        handleRequestError({
          error,
          email
        });
        setActiveKey(['4']);
      }
    });

    return function onFinish(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleScenarioChange = (code, formValues) => {
    var current = form.getFieldsValue();

    var newFormValues = _.reduce(current, function (result, value, key) {
      if (_.has(formValues, key)) {
        result[key] = formValues[key];
      } else {
        result[key] = _objectSpread(_objectSpread({}, value), {}, {
          checked: false
        });
      }

      return result;
    }, {});

    setCodeValues(code); // setInitial(formValues);
    // return onReset();

    form.setFieldsValue(newFormValues);
  };

  var handleOutputClick = e => {
    var {
      key
    } = e;
    setOutputAs(key);
  };

  var onValuesChange = (changedValues, allValues) => {
    setCodeValues(getCodeValues(allValues));
  };

  var requestPanelProps = {
    outputAs,
    loading: false,
    isLoggedIn,
    handleNotLoggedIn,
    handleOutputClick
  };
  var controlPanelProps = {
    form,
    initialScenarioId,
    endpoint,
    isAdmin,
    handleScenarioChange
  };
  var codeSamplesProps = {
    type: 'excel',
    config: {
      endpoint,
      customFunction,
      value: _objectSpread({}, codeValues)
    }
  };

  if (customFunction === 'QUERYA' || customFunction === 'QUERY') {
    codeSamplesProps.config.value = _objectSpread(_objectSpread({}, codeSamplesProps.config.value), {}, {
      provider: endpoint.provider.name,
      endpoint: endpoint.name
    });
  }

  var outputProps = {
    data: error || requestedData,
    loading,
    closeDrawer: () => setOutputDrawerVisible(false),
    drawerVisible: outputDrawerVisible,
    screenWidth
  };
  return /*#__PURE__*/React.createElement(Form, {
    id: "console-form",
    form: form,
    initialValues: initial,
    onValuesChange: onValuesChange,
    onFinish: onFinish,
    scrollToFirstError: true
  }, /*#__PURE__*/React.createElement(RequestPanel, requestPanelProps), /*#__PURE__*/React.createElement(ControlPanel, controlPanelProps), /*#__PURE__*/React.createElement(StyledCollapse, {
    bordered: false,
    onChange: setActiveKey,
    activeKey: activeKey // defaultActiveKey={defaultActiveKey}

  }, /*#__PURE__*/React.createElement(Panel, {
    header: "Query Builder",
    key: "1" // extra={this.genQueryBuilderDocsExtra()}
    ,
    extra: /*#__PURE__*/React.createElement(ExtraQueryBuilder, {
      customFunction: customFunction,
      setCustomFunction: setCustomFunction,
      onChange: setQueryInfoVisible
    }),
    style: {
      backgroundColor: 'white'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundColor: 'white',
      paddingLeft: 5
    }
  }, /*#__PURE__*/React.createElement(CodeSamples, codeSamplesProps))), /*#__PURE__*/React.createElement(Panel, {
    id: "console-collapse-custom",
    header: "Global Parameters",
    key: "2",
    className: "console-collapse-custom",
    extra: /*#__PURE__*/React.createElement(ExtraGlobal, {
      values: codeValues,
      onChange: setGlobalInfoVisible
    }),
    forceRender: true
  }, /*#__PURE__*/React.createElement(ParametersWrapper, null, globalParameters.map((parameter, index) => {
    var rowProps = {
      key: "global-".concat(parameter.name),
      index,
      parameter
    };
    return /*#__PURE__*/React.createElement(ParameterRow, rowProps);
  }))), /*#__PURE__*/React.createElement(Panel, {
    id: "console-collapse-custom",
    header: "Endpoint Parameters",
    key: "3" // extra={this.genEndpointExtra()}
    ,
    extra: /*#__PURE__*/React.createElement(ExtraParameters, {
      values: codeValues,
      onChange: setEndpointInfoVisible
    })
  }, /*#__PURE__*/React.createElement(ParametersWrapper, null, endpointParameters.map((parameter, index) => {
    var rowProps = {
      key: "endpoint-".concat(parameter.name),
      index,
      parameter
    };
    return /*#__PURE__*/React.createElement(ParameterRow, rowProps);
  })), _.isEmpty(endpointParameters) && /*#__PURE__*/React.createElement(Empty, {
    image: Empty.PRESENTED_IMAGE_SIMPLE,
    description: "No parameters. Click 'Make Request'"
  })), /*#__PURE__*/React.createElement(Panel, {
    header: "Output",
    key: "4",
    style: {
      backgroundColor: 'white'
    },
    forceRender: true,
    extra: /*#__PURE__*/React.createElement(ExtraOutput, {
      onChange: setOutputDrawerVisible
    })
  }, /*#__PURE__*/React.createElement(Output, outputProps))), /*#__PURE__*/React.createElement(DocsQueryBuilder, {
    drawerVisible: queryInfoVisible,
    closeDrawer: () => setQueryInfoVisible(false)
  }), /*#__PURE__*/React.createElement(DocsGlobalParameters, {
    drawerVisible: globalInfoVisible,
    closeDrawer: () => setGlobalInfoVisible(false)
  }), /*#__PURE__*/React.createElement(DocsEndpointParameters, {
    endpoint: endpoint,
    drawerVisible: endpointInfoVisible,
    closeDrawer: () => setEndpointInfoVisible(false)
  }));
}

ConsoleForm.propTypes = {
  host: PropTypes.string,
  isAdmin: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  handleNotLoggedIn: PropTypes.func,
  endpoint: PropTypes.object,
  parameters: PropTypes.array,
  customFunction: PropTypes.string
};
ConsoleForm.defaultProps = {
  host: 'web',
  customFunction: 'QUERYA'
};
export default ConsoleForm;